module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d976c682d8eb881e64c715933175133b.png";